import { render, staticRenderFns } from "./MembershipForm.vue?vue&type=template&id=2810074a&"
import script from "./MembershipForm.vue?vue&type=script&lang=js&"
export * from "./MembershipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports